import { leadAPI } from "./index"

export type SendMyQuoteBody = {
  quote_id: string
  user_id: string
  email_sent_to: string
  locale: string
}

export class SendMyQuoteError extends Error {
  constructor(public readonly status: number, public readonly code?: string) {
    super(`send-my-quote: ${status}${code ? ` (${code})` : ""}`)
    this.name = "SendMyQuoteError"
  }
}

export async function sendMyQuote(data: SendMyQuoteBody): Promise<void> {
  try {
    await leadAPI.post("quote/send-link", { json: data })
  } catch (error) {
    const response = (error as any).response as Response | undefined
    if (response) {
      let code: string | undefined
      try {
        const body = (await response.clone().json()) as { code?: string }
        code = body.code
      } catch {}
      throw new SendMyQuoteError(response.status, code)
    }
    throw new SendMyQuoteError(0)
  }
}
